// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext, useMemo} from 'react';
import {Settings_context} from '../settings_ctx';
import {use_translation_v} from '../lib/trans_v';
import cn from 'classnames';
import zcountry from 'zcountry';
import {hola_countries} from 'hola_opt';
import {use_countries} from '../ui/forms/use_countries';
import {Editor} from '../../../shared/editor/editor';
import styles from './ips.module.less';

const format_data = (amount, condition, closest_min, closest_max)=>{
    if (amount > condition)
    {
        return (Math.round(amount / closest_max) * closest_max)
            .toLocaleString();
    }
    if (closest_min==50)
    {
        return Math.max(amount<1 ? 0 : Math.round(amount / 10) * 10,
            Math.round(amount / closest_min) * closest_min).toLocaleString();
    }
    return (Math.round(amount / closest_min) * closest_min).toLocaleString();
};

interface i_ips_props {
    country: string;
}

export const Ips = ({country}: i_ips_props)=>{
    const {theme} = useContext(Settings_context);
    const {t} = use_translation_v();
    const {countries} = use_countries('fsvg_4x3', cn(styles.flag_wrap,
        theme.xs, theme.P), styles.flag_icon, null, null, true);
    const curr_country = useMemo(()=>countries.find(el=>
        el.title.toUpperCase()==(country||'')?.toUpperCase()),
    [country, countries]);
    const adj = zcountry.adj_list[curr_country?.value] ||
        zcountry.extra_adj_list[curr_country?.value] || null;
    const stats = {
        ips: format_data(hola_countries[curr_country?.value] || 0,
            1000, 50, 500),
        worldwide: format_data(hola_countries.total_ips || 0,
            100000, 5000, 10000),
        users: format_data(hola_countries?.user_connected[curr_country?.value]
            || 0, 1000, 50, 500),
    };
    return <div className={styles.ips_wrapper}>
      <div>
        <p className={cn(theme.H5, theme.color_n700)}>
          {stats.ips}
        </p>
        <span className={cn(theme.p3, theme.reg, theme.color_n600)}>
          {adj?.adj} IPs
        </span>
      </div>
      <div>
        <p className={cn(theme.H5, theme.color_n700)}>
          {stats.worldwide}
        </p>
        <span className={cn(theme.p3, theme.reg, theme.color_n600)}>
          {t('locations.ips.worldwide')} IPs
        </span>
      </div>
      <div>
        <p className={cn(theme.H5, theme.color_n700)}>
          {hola_countries.user_connected && stats.users}
        </p>
        <span className={cn(theme.p3, theme.reg, theme.color_n600)}>
          {t('locations.ips.users_connected', {
            country: curr_country?.title,
          })}
        </span>
      </div>
    </div>;
};

interface i_ips_editor_props {
    value: unknown;
    on_change: (new_val: unknown)=>void;
}

export const Ips_editor = ({value, on_change}: i_ips_editor_props)=>{
    return <Editor value={value} on_change={on_change} editors={[]}/>;
};
